import SettingConfig from '@module/config/setting';
import convertFormData from '@module/utils/convertFormData';
import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type { ApiBaseResponse } from '../../type';
import type {
  AdChatResponse,
  FetchAdChatParams,
  FetchChatChannelUserListParams,
  FetchChatChannelUserListResponse,
  FetchChatTranslateParams,
  FetchChatTranslateResponse,
  FetchSupporterChatNoticeParams,
  FetchSupporterChatNoticeResponse,
  FreezeChatRoomParams,
  FreezeChatRoomResponse,
  PostChatMessageParams,
  PostChatMessageResponse,
  RefreshTokenMessageParams,
  RefreshTokenResponse,
  SaveAdChatParams,
} from './type';

export const postChatMessage = async (postChatMessageParams: PostChatMessageParams) => {
  const res = await fetchExtended(`/v1/chat/message`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(postChatMessageParams),
  });

  const result = await res.json();

  return result as PostChatMessageResponse;
};

export const refreshToken = async (refreshTokenParams: RefreshTokenMessageParams) => {
  const res = await fetchExtended(refreshTokenParams.endpoint ?? `/v1/chat/refresh_token`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData({
      channel: refreshTokenParams.channel,
      token: refreshTokenParams.token,
    }),
  });

  const result = await res.json();

  return result as RefreshTokenResponse;
};

export const freezeChatRoom = async (freezeChatRoomParams: FreezeChatRoomParams) => {
  const res = await fetchExtended(`/v1/chat/room_freeze`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(freezeChatRoomParams),
  });

  const result = await res.json();

  return result as FreezeChatRoomResponse;
};

// api가 channel_user_global_list로 완전 대체될 예정임. 현재는 bktv 우선 적용이기에 아래처럼 분기
// 완전 대체 확정 시 통일 예정
export const fetchChatChannelUserList = async (params: FetchChatChannelUserListParams) => {
  const searchParams = new URLSearchParams();
  searchParams.append('channel', params.channel);
  searchParams.append('token', params.token);
  if (params.locale) searchParams.append('locale', params.locale);
  if (params.limit) searchParams.append('limit', String(params.limit));

  const endpoint = SettingConfig.isProd ? 'channel_user_list' : 'channel_user_global_list';
  const res = await fetchExtended(`${SettingConfig.CACHE_API_URL}/v1/chat/${endpoint}?${searchParams.toString()}`, {
    method: 'GET',
    credentials: 'omit',
  });

  const result = await res.json();

  return result as FetchChatChannelUserListResponse;
};

export const fetchAdChatConfig = async (params: FetchAdChatParams) => {
  const res = await fetchExtended(`/v1/config/block`, {
    method: 'POST',
    credentials: 'omit',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as AdChatResponse;
};

export const fetchSaveAdChat = async (params: SaveAdChatParams) => {
  const res = await fetchExtended(`/v1/chat/saveAdChat`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchChatTranslate = async (params: FetchChatTranslateParams) => {
  const res = await fetchExtended(`${SettingConfig.CACHE_API_URL}/v1/chat/translate`, {
    method: 'POST',
    credentials: 'omit',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as FetchChatTranslateResponse;
};

export const fetchSupporterChatNotice = async (params: FetchSupporterChatNoticeParams) => {
  const res = await fetchExtended(`/v1/chat/support_chat_notice`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as FetchSupporterChatNoticeResponse;
};
